import { Logo } from '@web-libs/features/branding/logo/ui/logo';
import cssStyles from '@web-libs/ui/layout-components/common-page-ui/structural-elements/public-header.module.css';
import { MobileMenu } from '@web-libs/features/navigation/mobile-menu';
import { getCssVar } from '@web-libs/features/colors/application/colors';

export const AuthenticatedMobileHeader = ({ addPadding = true }: { addPadding?: boolean }) => {
  return (
    <div style={{
      padding: addPadding ? '0px 20px' : 0,
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      backgroundColor: getCssVar('light'),
      boxShadow: '0 4px 10px 0 rgba(0,0,0,0.1)'
    }} className={cssStyles.mobileWrapper}>
      <div style={{ maxHeight: 64, height: 64 }}>
        <Logo fitParent />
      </div>
      <div>
        <MobileMenu isPublicArea={false} />
      </div>
    </div>
  );
};
